var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.author
    ? _c("div", { staticClass: "AuthorCard" }, [
        _c(
          "div",
          {
            staticClass: "data",
            style: {
              background:
                "linear-gradient(rgba(255, 255, 255, 0), rgba(0, 0, 0, 0.8) 60%), url(" +
                _vm.imageRoute +
                ") no-repeat center center/cover"
            }
          },
          [
            _c("h2", [
              _vm._v(
                " " +
                  _vm._s(_vm.author.Nombre) +
                  " " +
                  _vm._s(_vm.author.Apellidos) +
                  " "
              )
            ]),
            _c(
              "div",
              { staticClass: "categories" },
              _vm._l(_vm.author.userdatas, function(disciplina) {
                return _c(
                  "p",
                  { key: disciplina.id, staticClass: "category" },
                  [_vm._v(" " + _vm._s(disciplina.disciplina.txt) + " ")]
                )
              }),
              0
            )
          ]
        )
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }